var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 30.3333C8.09317 30.3333 1.6665 23.9066 1.6665 16C1.6665 8.09329 8.09317 1.66663 15.9998 1.66663C23.9065 1.66663 30.3332 8.09329 30.3332 16C30.3332 23.9066 23.9065 30.3333 15.9998 30.3333ZM15.9998 3.66663C9.19984 3.66663 3.6665 9.19996 3.6665 16C3.6665 22.8 9.19984 28.3333 15.9998 28.3333C22.7998 28.3333 28.3332 22.8 28.3332 16C28.3332 9.19996 22.7998 3.66663 15.9998 3.66663Z",
    fill: "#00A14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 20.7733C11.9733 20.7733 11.72 20.68 11.52 20.48C11.1333 20.0933 11.1333 19.4533 11.52 19.0666L19.0666 11.52C19.4533 11.1333 20.0933 11.1333 20.48 11.52C20.8666 11.9066 20.8666 12.5466 20.48 12.9333L12.9333 20.48C12.7466 20.68 12.48 20.7733 12.2266 20.7733Z",
    fill: "#00A14B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7733 20.7733C19.52 20.7733 19.2666 20.68 19.0666 20.48L11.52 12.9333C11.1333 12.5466 11.1333 11.9066 11.52 11.52C11.9066 11.1333 12.5466 11.1333 12.9333 11.52L20.48 19.0666C20.8666 19.4533 20.8666 20.0933 20.48 20.48C20.28 20.68 20.0266 20.7733 19.7733 20.7733Z",
    fill: "#00A14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ecc4dcaa509367b243867f0dbf676002.svg";
export { ForwardRef as ReactComponent };